import { useState } from 'react'
import { Link } from 'react-router-dom'
import { isAnalyticsAvailable, setConsent, storedConsent } from '../lib/analytics'
import { useT } from '../i18n'

/**
 * Bandeau de consentement. Deux boutons de poids égal : un « refuser » caché ou
 * dévalorisé face à un « accepter » proéminent est précisément ce que la CNIL
 * sanctionne. Refuser doit être aussi facile qu'accepter.
 */
export default function ConsentBanner() {
  const t = useT()
  const [answered, setAnswered] = useState(() => storedConsent() !== null)

  if (answered || !isAnalyticsAvailable) return null

  function answer(granted: boolean) {
    setConsent(granted)
    setAnswered(true)
  }

  return (
    <div className="consent" role="dialog" aria-label="Cookies">
      <p>
        {t.consent.text}{' '}
        <Link to="/privacy">{t.consent.privacyLink}</Link>.
      </p>
      <div className="consent-actions">
        <button className="btn btn-ghost" onClick={() => answer(false)}>{t.consent.decline}</button>
        <button className="btn btn-primary" onClick={() => answer(true)}>{t.consent.accept}</button>
      </div>
    </div>
  )
}
